import React from "react";
import "./App.css";

export default function Week() {
    return (
        <div className="Week">
            <h3>THIS WEEK</h3>
        </div>
    );
}